import OrderNotesComponent from "./component/OrderNotes.svelte";
const NAME = 'wc_order_notes';
AC_SERVICES.addListener('Editing.Editables.Ready', (Editables) => {
    const Abstract = Editables.get('_abstract');
    class OrderNotes extends Abstract {
        constructor(args) {
            super(args);
            this.dynamicValue = [];
        }
        getEditableType() {
            return NAME;
        }
        valueToInput(value) {
            this.dynamicValue = value;
            let container = this.getElement().querySelector('[data-component]');
            this.component = new OrderNotesComponent({
                target: container,
                props: {
                    value: this.dynamicValue,
                    mode: this.settings.mode,
                    canAdd: this.settings.canAdd,
                    canEdit: this.settings.canEdit
                }
            });
        }
        getValue() {
            return this.component.getValue();
        }
        getTemplate() {
            return `<div data-component></div>`;
        }
    }
    Editables.registerEditable(NAME, OrderNotes);
});
AC_SERVICES.addListener('Editing.Middleware.Ready', (Middleware) => {
    const Abstract = Middleware.getClass('_abstract');
    class OrderNotes extends Abstract {
        map() {
            this.args.mode = this.settings.mode;
            this.args.canEdit = false;
            this.args.canAdd = false;
            if ('customer' === this.args.mode) {
                this.args.canAdd = true;
            }
            if ('private' === this.args.mode) {
                this.args.canEdit = true;
                this.args.canAdd = true;
            }
            return this.args;
        }
        getEditable() {
            return this.Editables.get(NAME);
        }
    }
    Middleware.register(NAME, OrderNotes);
});
